import { useCallback, useEffect } from "react";

/**
 * Prevents browser print dialog when specific elements are focused
 */
export const usePreventBrowserShortcuts = (isActive: boolean) => {
    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (!isActive) {
                return;
            }

            // Prevent print dialog: Ctrl+P on Windows/Linux, Cmd+P on Mac
            if (event.key === "p" && !event.shiftKey && !event.altKey) {
                const isMac = navigator.platform.toUpperCase().includes("MAC");
                const hasCorrectModifier = isMac ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;

                if (hasCorrectModifier) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
            }
        },
        [isActive],
    );

    useEffect(() => {
        if (!isActive) {
            return;
        }

        document.addEventListener("keydown", handleKeyDown, { capture: true });

        return () => {
            document.removeEventListener("keydown", handleKeyDown, { capture: true });
        };
    }, [handleKeyDown, isActive]);
};
